import React, { Component } from "react";

export default class Dashboard extends Component {
  render() {
    return <div />;
  }
}



// WEBPACK FOOTER //
// ./src/pages/Dashboard/index.js